import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const DiscountService = {
  // Fetch discounts with optional filters (isActive, discountType, discountFor)
  getList: async (filters = {}) => {
    try {
      const response = await apiService.get("/discount", { params: filters });
      return response.data;
    } catch (error) {
      console.error("Error fetching discount list:", error);
      throw error;
    }
  },

  // Get detail of a single discount
  getDetail: async (id) => {
    const response = await apiService.get(`/discount/${id}`);
    return response.data;
  },

  // Create a new discount
  create: async (data) => {
    const response = await apiService.post("/discount", data);
    return response.data;
  },

  // Update discount by ID
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/discount/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating discount:", error);
      throw error;
    }
  },

  // Delete discount by ID
  delete: async (id) => {
    const response = await apiService.delete(`/discount/${id}`);
    return response.data;
  },
  getAvailableDiscounts: async () => {
    const response = await apiService.get("/discount/(available-discount)");
    return response.data;
  },
};

export default DiscountService;
